module.exports = __webpack_public_path__ + "img/iconHistoryOrder.1f54270a.svg";